import { Sort } from '@angular/material/sort';

import { createReducer, Action, on } from '@ngrx/store';
import { difference, mergeWith } from 'lodash-es';

import { TermExplorerActions } from './term-explorer.actions';
import { TermExplorerState } from './term-explorer.state';
import { measureReducer } from '../../features/shared/utils/runtime-reducer-stats';

export const initialState: TermExplorerState = {
  loading: false,
  focusMode: false,
  sort: {
    active: 'definedTerm',
    direction: 'asc',
  } as Sort,
};

const featureReducer = measureReducer(
  createReducer(
    initialState,
    on(TermExplorerActions.LoadFinalDocumentTerms, (state, action) => ({
      ...state,
      loading: true,
      finalTerms: null,
      finalDocumentId: action.documentId,
      error: undefined,
    })),
    on(TermExplorerActions.LoadOriginalDocumentTerms, (state, action) => ({
      ...state,
      loading: true,
      originalTerms: null,
      originalDocumentId: action.documentId,
      error: undefined,
    })),
    on(
      TermExplorerActions.LoadFinalDocumentTermsFail,
      TermExplorerActions.LoadDefinedTermOccurenceFail,
      (state, action) => ({
        ...state,
        loading: false,
        loadingOccurencies: false,
        error: action.error,
      })
    ),
    on(TermExplorerActions.LoadFinalDocumentTermsSuccess, (state, action) => ({
      ...state,
      loading: false,
      finalTerms: action.list,
    })),
    on(TermExplorerActions.LoadOriginalDocumentTermsSuccess, (state, action) => ({
      ...state,
      loading: false,
      originalTerms: action.list,
    })),
    on(TermExplorerActions.CleanOriginalDocumentTerms, (state, action) => ({
      ...state,
      loading: false,
      originalTerms: null,
      focusMode: false,
    })),
    on(TermExplorerActions.LoadDefinedTermOccurences, (state, action) => ({
      ...state,
      transactionIdsToDownload: action.transactionIds,
      occurencesByFilter: {},
      loadingOccurencies: !!action.transactionIds?.length,
    })),
    on(TermExplorerActions.LoadDefinedTermOccurenceChunkSuccess, (state, action) => ({
      ...state,
      occurencesByFilter: mergeWith(
        { ...state.occurencesByFilter },
        action.occurences,
        (left, right) => (+left || 0) + (+right || 0)
      ),
      transactionIdsToDownload: difference(state.transactionIdsToDownload, action.transactionIds),
      loadingOccurencies: false,
    })),
    on(TermExplorerActions.SetTermScope, (state, action) => ({
      ...state,
      termScope: action.termScope,
    })),
    on(TermExplorerActions.SetSort, (state, action) => ({ ...state, sort: action.sort })),
    on(TermExplorerActions.SetFocusMode, (state, action) => ({
      ...state,
      focusMode: action.focusMode,
    }))
  )
);

export function reducer(state: TermExplorerState | undefined, action: Action) {
  return featureReducer(state, action);
}
